import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { track } from '@fff-web/fff-analytics';
import PaymentMethod from '@fff-web/fff-ui-shared/PaymentMethod';
import { RecurlyProvider, Elements } from '@recurly/react-recurly';
import isEmpty from 'lodash/isEmpty';
import env from 'pages/MyAccount/utils/env';
import {
  ACCOUNT_SECTIONS,
  ACCOUNT_TRACK_NAMES,
} from 'pages/MyAccount/utils/segment';

import PaymentForm from './PaymentForm';
import styles from './Payment.module.css';

const BUTTON_CTAS = {
  edit: 'Edit',
  cancel: 'Cancel',
};

const Payment = ({ billingInfo, setBillingInfo }) => {
  const { lastFour, cardType, month, year } = billingInfo;
  const missingBillingInfo = !lastFour || !cardType || !month || !year;
  const [isEditing, setIsEditing] = useState(false);
  const toggleIsEditing = () => setIsEditing((prevState) => !prevState);
  if (isEmpty(billingInfo)) {
    return null;
  }

  const handleClickEdit = () => {
    if (!isEditing) {
      track({
        trackName: ACCOUNT_TRACK_NAMES.started,
        properties: {
          cta_name: BUTTON_CTAS.edit,
          account_section: ACCOUNT_SECTIONS.billing,
        },
      });
    }
    toggleIsEditing();
  };

  return (
    <RecurlyProvider publicKey={env.recurlyPublicKey}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h4 data-testid="payment-title-text">Payment</h4>
          <button onClick={handleClickEdit} type="button" data-testid="edit-btn-payment">
            {isEditing ? BUTTON_CTAS.cancel : BUTTON_CTAS.edit}
          </button>
        </div>
        {missingBillingInfo ? (
          <p>Please add your payment method.</p>
        ) : (
          <div
            className={`${styles.cardNumber} ${isEditing ? styles.edit : ''}`}
          >
            <PaymentMethod billingInformation={billingInfo} />
          </div>
        )}

        {isEditing && (
          <Elements>
            <PaymentForm
              onClose={() => setIsEditing(false)}
              billingInfo={billingInfo}
              setBillingInfo={setBillingInfo}
            />
          </Elements>
        )}
      </div>
    </RecurlyProvider>
  );
};

Payment.propTypes = {
  billingInfo: PropTypes.shape({}).isRequired,
  setBillingInfo: PropTypes.func.isRequired,
};

export default Payment;
